import { takeLatest, call, put, select, fork } from "redux-saga/effects";
import { delay } from "redux-saga";

import moment from "moment";

import { replace, push } from "react-router-redux";

import request from "api";

import ReactGA from "react-ga";
import TwitterConvTrkr from "react-twitter-conversion-tracker";
import LinkedInTag from 'react-linkedin-insight';

import * as actions from "./actions";


TwitterConvTrkr.init("nzia7");
LinkedInTag.init("656946");

const tabOrder = [
  "tab0",
  "tab0b",
  "tab1",
  "turnover",
  "single-invoice-file",
  "single-invoice-company",
  "single-invoice-check",
  "single-invoice-price",
  "single-invoice-redirect",
  "drawn-down",
  "tab2",
  "tab3a",
  "tab3b",
  "tab4a",
  "tab4b",
  "tab5a",
  "tab5b",
  "tab6",
  "tab7"
];

const getAppState = state => state.app;

function* getSubdomainInfo() {
  const { status, data } = yield call(request, {
    url: "Channel/GetChannel?hostname=" + window.location.hostname
  });

  if (status === 200) {
    //set document title with result of GetChannel
    document.title = data.Name;

    //save domain info to redux
    yield put({ type: actions.GET_SUBDOMAIN_INFO_OK, data });
  }
}

function* getSession(action) {
  const { sessionId } = action;

  const { status, data } = yield call(request, {
    url: "Quote/Retrive?Guid=" + sessionId
  });

  if (status === 200) {
    // yield call(updateUrl, "tab6", sessionId, true);

    let activeTab = data.activeTab;

    if (activeTab === undefined) {
      activeTab = "tab0";
    } else if (data.forceSingleInvoice && tabOrder.indexOf(data.activeTab) >= tabOrder.indexOf("drawn-down")) {
      activeTab = "single-invoice-file";
    }

    yield call(updateUrl, activeTab, sessionId, true);
    ReactGA.pageview(
      "/quote/?activeTab=" + activeTab + "&session=" + sessionId
    );
    yield put({ type: actions.GET_SESSION_OK, sessionId, data });
  }
}

function* createSession(action) {
  const { status, data } = yield call(request, {
    method: "POST",
    url: "Quote/Create"
  });

  //Check resp
  if (status === 200) {
    //yield call(updateUrl, "tab6", data.Guid, true);
    yield call(updateUrl, tabOrder[0], data.Guid, true);
    // yield call(updateUrl, "turnover", data.Guid, true);
    yield put({
      type: actions.CREATE_SESSION_OK,
      sessionId: data.Guid,
      refNumber: data.ReferenceNumber
    });

    //hit update with just ref number
    yield call(updateSession, "tab0");
  }
}

function* updateUrl(tab, sessionId, replaceBool = false) {
  // tab = "tab4a";

  /* let url = "/quote/?activeTab=" + tab + "&session=" + sessionId;

  if (gclid !== null && gclid !== undefined) {
    url += "&gclid=" + gclid;
  }*/

  // yield delay(300);

  const url = "/quote/?activeTab=" + tab + "&session=" + sessionId;

  if (replaceBool) {
    yield put(replace(url));
  } else {
    yield put(push(url));
  }
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


function* ping()
{
  while(true) {
    const s = yield select(getAppState);
    let options = {
      method: "POST",
      url: "Quote/Ping?Guid=" + s.sessionId,
    }
    yield call(request, options);
    //loop every minute
    yield call(delay, 60000);
  }
}

function* getPriceSingleInvoice() {
  yield put({ type: actions.NEXT_STEP_BTN_START_LOADING });
  //get state tree
  const s = yield select(getAppState);

  //build formdata
  let formData = new FormData();

  formData.append("singleInvoiceFile", s.singleInvoiceFile);
  formData.append("singleInvoiceCompanyName", s.singleInvoiceCompanyName);
  formData.append("singleInvoiceCompanyNumber", s.singleInvoiceCompanyNumber);
  formData.append("singleInvoiceAmount", s.singleInvoiceAmount);
  formData.append("singleInvoiceDueDate", moment(s.singleInvoiceDueDate).utcOffset(0, true).toISOString(),);
  formData.append("singleInvoiceIssueDate", moment(s.singleInvoiceIssueDate).utcOffset(0, true).toISOString());
  formData.append("singleInvoiceNumber", s.singleInvoiceNumber);

  const { status, data } = yield call(request, {
    url: "Quote/PriceSingleInvoice?Guid=" + s.sessionId,
    method: "POST",
    data: formData
  });
  
  let payload = {
    singleInvoiceReferralUrl: data.ReferralUrl,
    singleInvoiceTotalPrice: data.TotalPrice,
    singleInvoiceRejectionReason: data.RejectionReason,
    singleInvoiceAmount: s.singleInvoiceAmount,
    singleInvoiceAmountProtected: (s.singleInvoiceAmount * 0.9),
    singleInvoiceStatus: data.Status
  };

  yield put({ type: actions.SINGLE_INVOICE_PRICE_OK, payload });
  yield put({ type: actions.NEXT_STEP_BTN_FINISH_LOADING });
}

function* updateSession(nextTab) {
  //get state tree
  const s = yield select(getAppState);

  //create axios options
  let options = {
    method: "POST",
    url: "Quote/Update?Guid=" + s.sessionId,
    data: {
      activeTab: nextTab,
      refNumber: s.refNumber,
      forceSingleInvoice: s.forceSingleInvoice,
      //tab0
      fullName: s.fullName, //string
      email: s.email, //string
      phoneNumber: s.phoneNumber, //string
      acceptedTerms: s.acceptedTerms, // bool
      //tab1
      tab1ShowExtraFields: s.tab1ShowExtraFields, //bool
      tab1AutoFillDone: s.tab1AutoFillDone, //bool
      companyName: s.companyName, //string
      companyNumber: s.companyNumber, //int
      companyAddress: s.companyAddress, //string
      companyDescription: s.companyDescription, //string
      //tab1 - turnover
      companyPredictedTurnover: s.companyPredictedTurnover,
      //tab1 - drawn down
      requiresInvoiceFinance: s.requiresInvoiceFinance,
      // companyPredictedTurnover: 5000,
      //tab2
      tradesOutsideOfTheUk: s.tradesOutsideOfTheUk, //bool
      //tab3
      countries: s.countries, //array
      //example of country object : {value : "AS",label : string,annualSales : number,approxCustomers : number,creditTerms : number}
      //tab4
      years: s.years, //array
      //example of year object : {value : "2017",label : "2017-2018",totalSales : number,totalBadDebts : number,largestBadDebt : number}
      //tab5
      customers: s.customers
      //Example of customer object : {companyName : string,companyAddres : string,companyNumber : int,highestAmountOwing : int}
    }
  };

  //check headers
  const gclid = getCookie("gclid");
  if (gclid !== "") {
    options.headers = {
      gclid
    };
  }

  yield call(request, options);
}

function* moveTab(action) {
  const { dir, from, tab2Answer } = action;
  const { sessionId } = yield select(getAppState);

  //find next tab
  let nextTab =
    dir === "next"
      ? tabOrder[tabOrder.indexOf(from) + 1]
      : tabOrder[tabOrder.indexOf(from) - 1];

  if (dir === "back") {
    yield call(updateUrl, nextTab, sessionId);
    return;
  }

  switch (from) {
    case "tab0":
      //start pinging backend to let them know we are here
      yield put({ type: actions.START_PING});
      TwitterConvTrkr.pageView();
      LinkedInTag.track("738106");
      console.log("track conv");
      
      break;

    case "tab1":
      const { tab1AutoFillDone, companyName } = yield select(getAppState);

      if (!tab1AutoFillDone) {
        //trigger autofill
        yield put({
          type: actions.COMPANY_SEARCH_LOAD,
          q: companyName,
          fromTab: from
        });
        return;
      }
      break;

    case "tab2":
      if (!tab2Answer) {
        //overide next tab
        nextTab = "tab4a";
      }
      break;
    case "turnover":
      const { companyPredictedTurnover, forceSingleInvoice, domain } = yield select(
        getAppState
      );
      nextTab = "drawn-down";

      let turnover = parseInt(companyPredictedTurnover, 10);
      if (turnover === Number.NaN) {
        turnover = 0;
      }
      //turnover is over 5000 - to avoid million entry and is less than the single invoice threshold
      let turnoverIsWithinThreshold = (turnover > 5000 && turnover < domain.SingleInvoiceThreshold)
      if (domain.SingleInvoiceEnabled && (forceSingleInvoice || turnoverIsWithinThreshold)) {
        nextTab = "single-invoice-file";
      }

      break;

    case "single-invoice-company":
      const {
        singleInvoiceCompanyName,
        singleInvoiceAutoFillDone
      } = yield select(getAppState);
      if (!singleInvoiceAutoFillDone) {
        yield put({
          type: actions.COMPANY_SEARCH_LOAD,
          q: singleInvoiceCompanyName,
          fromTab: "singleInvoiceCompany"
        });
        return;
      }

      break;
    case "single-invoice-check":
      yield call(getPriceSingleInvoice);
      break;

    case "tab4a":
      const { yearsNotSure, years } = yield select(getAppState);
      if (yearsNotSure || years.length === 0) {
        //override next tab
        nextTab = "tab5a";
      }
      break;

    case "tab5b":
      {
        yield call(updateSession, nextTab);

        const { companyPredictedTurnover } = yield select(getAppState);
        const { domain } = yield select(getAppState);
        if (companyPredictedTurnover >= 0) {
          //skip pricing
          nextTab = "tab7";
        } else if (domain.Country !== "uk") {
          nextTab = "tab7";
        } else {
          const { status, data } = yield call(request, {
            url: "Quote/Price?product=II&guid=" + sessionId,
            method: "POST"
          });
          if (status === 200) {
            yield put({ type: actions.TAB_6_REQUEST_PRICE_OK, newP: data });
          } else {
            nextTab = tabOrder[tabOrder.indexOf(from) + 2];
            yield fork(updateSession, nextTab);
          }
        }
      }

      break;
    case "tab6":
      TwitterConvTrkr.pageView();
      break;

    default:
      break;
  }

  if (dir === "next") {
    yield call(updateUrl, nextTab, sessionId);
    if (
      from !== "tab5b" &&
      from !== "single-invoice-company" &&
      from !== "single-invoice-file" &&
      from !== "single-invoice-check"
    ) {
      yield call(updateSession, nextTab);
    }
  }
}

function* searchForCompany(action) {
  yield put({ type: actions.NEXT_STEP_BTN_START_LOADING });
  const { domain } = yield select(getAppState);

  const { status, data } =
    domain.Country === "uk"
      ? yield call(request, {
          url: "CompanySearch/Search?company=" + action.q
        })
      : yield call(request, {
          url:
            "CompanySearch/InternationalSearch?Company=" +
            action.q +
            "&countryCode=" +
            domain.Country
        });

  if (status === 200) {
  yield put({ type: actions.NEXT_STEP_BTN_FINISH_LOADING });
    if (action.fromTab === "tab5a") {
      if (data.length === 0) {
        yield put({ type: actions.TAB_5A_ADD_CUSTOMER, name: action.q });
        return;
      }
    }

    yield put({
      type: actions.COMPANY_SEARCH_LOAD_OK,
      q: action.q,
      results: data,
      fromTab: action.fromTab,
      secondaryId: action.secondaryId
    });
  }
}

function* searchCompanySelected(action) {
  const { companySearchFromTab, domain } = yield select(getAppState);

  if (companySearchFromTab === "tab1") {
    //Now fetch the activities
    const { data } =
      domain.Country === "uk"
        ? yield call(request, {
            url:
              "CompanySearch/GetFullData?companyNumber=" +
              action.company.CompanyNumber
          })
        : { data: {} };

    //Populate tab1 with the company info
    yield put({
      type: actions.TAB_1_AUTOFILL_SELECTED,
      company: action.company,
      activities: data.SicCodes !== undefined ? data.SicCodes : {}
    });

    //move to next tab if country === uk
    if (domain.Country === "uk") {
      yield call(moveTab, { dir: "next", from: companySearchFromTab });
    }
  }

  if (companySearchFromTab === "singleInvoiceCompany") {
    yield put({
      type: actions.SINGLE_INVOICE_AUTOFILL,
      company: action.company
    });
  }

  if (companySearchFromTab === "tab5a") {
    //populate the right customer with the company info
    yield put({
      type: actions.TAB_5A_ADD_CUSTOMER_AUTOFILL,
      company: action.company
    });
  }

  yield put({ type: actions.COMPANY_SEARCH_HIDE, fromTab: companySearchFromTab, isTryAgain: false });
  yield delay(300);
  yield put({ type: actions.COMPANY_SEARCH_RESET_RESULTS });
}

function* searchCompanyReset(action) {
  const { companySearchQ } = yield select(getAppState);

  if (action.fromTab === "tab5a") {
    yield put({ type: actions.TAB_5A_ADD_CUSTOMER, name: companySearchQ });
  }

  yield put({
    type: actions.COMPANY_SEARCH_HIDE,
    fromTab: action.fromTab,
    isTryAgain: action.isTryAgain
  });
  yield delay(300);
  yield put({ type: actions.COMPANY_SEARCH_RESET_RESULTS });
}

export default function* appSaga() {
  //subdomain data
  yield takeLatest(actions.GET_SUBDOMAIN_INFO, getSubdomainInfo);
  //session
  yield takeLatest(actions.GET_SESSION, getSession);
  yield takeLatest(actions.CREATE_SESSION, createSession);
  //ping
  yield takeLatest(actions.START_PING, ping);
  //move_tab
  yield takeLatest(actions.MOVE_TAB, moveTab);
  //companySearch
  yield takeLatest(actions.COMPANY_SEARCH_LOAD, searchForCompany);
  yield takeLatest(actions.COMPANY_SEARCH_SELECTED, searchCompanySelected);
  yield takeLatest(actions.COMPANY_SEARCH_RESET, searchCompanyReset);
}
